export type Action = 'Create' | 'Update';

export const ActionMappingToLabel: Record<Action, string> = {
  Create: 'Tạo mới',
  Update: 'Ghi đè',
};
